import React, { useContext } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { LoadingButton } from "@mui/lab";
import { ExportContext } from "../../context/ExportProvider";
const ExportVisitorsButton = ({ filter }) => {
  const { exportVisitors, visitorExporting } = useContext(ExportContext);
  return (
    <>
      <LoadingButton
        onClick={() => exportVisitors(filter)}
        variant="outlined"
        loading={visitorExporting}
        startIcon={<FileDownloadIcon />}
      >
        Export to Excel
      </LoadingButton>
    </>
  );
};

export default ExportVisitorsButton;
